import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Output } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { FeedbackFormValue } from "@app/chat-bot/interfaces";
import { PhoenixButtonModule } from "@kehe/phoenix-button";
import { Counter } from "@kehe/phoenix-utils";
import { DropDownListModule } from "@progress/kendo-angular-dropdowns";
import {
  FormFieldModule,
  TextAreaModule,
} from "@progress/kendo-angular-inputs";
import { LabelModule } from "@progress/kendo-angular-label";
import { startWith } from "rxjs/operators";

@Component({
  selector: "app-feedback-form",
  imports: [
    CommonModule,
    DropDownListModule,
    TextAreaModule,
    LabelModule,
    FormFieldModule,
    ReactiveFormsModule,
    PhoenixButtonModule,
  ],
  templateUrl: "./feedback-form.component.html",
  styleUrl: "./feedback-form.component.scss",
})
export class FeedbackFormComponent {
  commentsMaxLength = 500;

  reasons: string[] = [
    "Response was incorrect",
    "Response was not helpful",
    "Response was too long",
    "Response was not based on company data",
    "Other",
  ];

  feedbackForm: FormGroup = new FormGroup({
    reason: new FormControl(this.reasons[0]),
    comments: new FormControl(""),
  });

  characterCounter = new Counter(
    this.commentsMaxLength,
    this.feedbackForm.controls.comments.valueChanges.pipe(startWith("")),
  );

  @Output() cancelForm = new EventEmitter<void>();
  @Output() submitForm = new EventEmitter<FeedbackFormValue>();

  onCancelClick(): void {
    this.cancelForm.emit();
  }

  onSubmitClick(): void {
    this.submitForm.emit(
      this.feedbackForm.value as unknown as FeedbackFormValue,
    );
  }
}
